/**
 * Teléfonos de contacto del sitio. Header, footer y datos estructurados (SEO)
 * los leen de aquí para que siempre muestren los mismos números.
 */
export const CONTACT_PHONES = ['300 557 1857', '323 658 0129', '300 557 2000', '302 859 3318'];

export const phoneHref = (phone) => `tel:${phone.replace(/\s/g, '')}`;

